import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';


import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { KeycloakAngularModule } from 'keycloak-angular';
// import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { JwtInterceptor } from './interceptor/jwt.interceptor';
import { CoverageInterceptor } from './interceptor/coverage.interceptor';
import { ErrorReportInterceptor } from './interceptor/error-report.interceptor';
import { GlobalErrorHandler } from './services/global-error-handler';
import { SafariViewController } from '@awesome-cordova-plugins/safari-view-controller/ngx';
import en from '@angular/common/locales/en';
import { LoadingComponent } from './components/loading/loading.component';
import { AlertModule } from '@coreui/angular';
import { MultiSelectModule } from 'primeng/multiselect';
import { ResizeObserverDirective } from './directives/resize-observer.directive';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { ManageDomainPage } from './pages/domains/manage-domain/manage-domain.page';
import { ConsentManagerComponent } from './components/consent-manager/consent-manager.component';

// import { LaraLightTheme } from 'primeng/resources/themes/lara-light/theme'; // adjust as needed


registerSwiperElements();
registerLocaleData(en);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    FormsModule,
    KeycloakAngularModule,
    TranslocoRootModule,
    NzDrawerModule,
    NzToolTipModule,
    NzModalModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule,
    CommonModule,
    LoadingComponent,
    AlertModule,
    MultiSelectModule,
    // LoadingComponent,
    ResizeObserverDirective,
    FilterPipe,
    ConsentManagerComponent,

  ],
  providers: [
    ManageDomainPage,
    provideAnimationsAsync(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: NZ_I18N, useValue: en_US },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: { preset: Aura, options: { darkModeSelector: '.p-dark' } },
    }),
    provideTransloco({
      config: {
        availableLangs: ['en', 'cn', 'ja', 'ko'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    // Turns the server's 423 `beyond_coverage` refusal into one explanation
    // with a way out, instead of a raw error toast on every posting screen.
    { provide: HTTP_INTERCEPTORS, useClass: CoverageInterceptor, multi: true },
    // Kept for triage: uncaught exceptions and 5xx / unreachable accounting calls.
    { provide: HTTP_INTERCEPTORS, useClass: ErrorReportInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAnimationsAsync(),
    provideHttpClient(),
    // provideCharts(withDefaultRegisterables()),
    OpenNativeSettings,
    SafariViewController
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule { }
